import { createFormHook } from "@tanstack/react-form";

import { CheckboxField } from "./FieldComponents/CheckboxField";
import { SelectField } from "./FieldComponents/SelectField";
import { TextField } from "./FieldComponents/TextField";
import { FormActionButtons } from "./FormComponents/FormActionButtons";
import { fieldContext, formContext } from "./form-context";

export const { useAppForm } = createFormHook({
  fieldComponents: {
    TextField,
    CheckboxField,
    SelectField,
  },
  formComponents: {
    FormActionButtons,
  },
  fieldContext,
  formContext,
});
